export default "__VITE_ASSET__7ynRgaxy__"